module.exports = __webpack_public_path__ + "img/shiba-loading.298a1af1.png";